import { gql } from '@apollo/client';

const CONTRIBUTION_TIMER_FIELDS = gql`
  fragment ContributionTimerFields on UserContributionTimer {
    id
    startedAt
    pausedAt
    pausedDurationSeconds
    stoppedAt
    discardedAt
    ipPerMinuteSnapshot
    contributionType {
      id
      slug
      name
      ipPerMinute
    }
    userContribution {
      id
      status
      effortMinutes
      ipAmount
      description
      ipCategory
      recipientCommunity {
        name
      }
      communityProject {
        name
      }
    }
  }
`;

export const RUNNING_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  query RunningContributionTimer {
    runningTimer: userContributionTimers(
      first: 1
      filter: { stoppedAt: { isNull: true } }
    ) {
      nodes {
        ...ContributionTimerFields
      }
    }
  }
`;

export const CONTRIBUTION_TIMER_PAGE = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  query ContributionTimerPage {
    runningTimer: userContributionTimers(
      first: 1
      filter: { stoppedAt: { isNull: true } }
    ) {
      nodes {
        ...ContributionTimerFields
      }
    }

    recentTimers: userContributionTimers(
      first: 10
      filter: {
        stoppedAt: { isNull: false }
        userContributionId: { isNull: false }
      }
      orderBy: [STARTED_AT_DESC]
    ) {
      nodes {
        ...ContributionTimerFields
      }
    }
  }
`;

export const START_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  mutation StartContributionTimer {
    startContributionTimer(
      input: {}
    ) {
      userContributionTimer {
        ...ContributionTimerFields
      }
    }
  }
`;

export const PAUSE_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  mutation PauseContributionTimer($timerId: UUID!) {
    pauseContributionTimer(input: { pTimerId: $timerId }) {
      userContributionTimer {
        ...ContributionTimerFields
        pausedAt
        pausedDurationSeconds
      }
    }
  }
`;

export const RESUME_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  mutation ResumeContributionTimer($timerId: UUID!) {
    resumeContributionTimer(input: { pTimerId: $timerId }) {
      userContributionTimer {
        ...ContributionTimerFields
        pausedAt
        pausedDurationSeconds
      }
    }
  }
`;

export const CONTRIBUTION_TIMER_OPTIONS = gql`
  query ContributionTimerOptions {
    contributionTypes: availableProjectContributionTypes { nodes { id name ipCategory } }
    currentUser {
      communityUsers(filter: { status: { equalTo: JOINED } }) {
        nodes {
          communityId
          community {
            id
            name
          }
        }
      }
    }
    communityContributionProjects: currentUserAvailableContributionProjects {
      nodes {
        id
        name
        shortDescription
        primaryCommunityId
        primaryCommunity { slug }
        canManage
        allowedContributionTypes { nodes { id name ipCategory } }
        additionalHostCommunities {
          nodes {
            id
          }
        }
      }
    }
  }
`;

export const FINALIZE_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  mutation FinalizeContributionTimer(
    $timerId: UUID!
    $communityId: UUID!
    $projectId: UUID!
    $description: String!
    $contributionTypeId: UUID!
  ) {
    finalizeContributionTimer(
      input: {
        pTimerId: $timerId
        pRecipientCommunityId: $communityId
        pCommunityProjectId: $projectId
        pDescription: $description
        pContributionTypeId: $contributionTypeId
      }
    ) {
      userContributionTimer {
        ...ContributionTimerFields
      }
    }
  }
`;

export const DISCARD_CONTRIBUTION_TIMER = gql`
  ${CONTRIBUTION_TIMER_FIELDS}

  mutation DiscardContributionTimer($timerId: UUID!) {
    discardContributionTimer(input: { pTimerId: $timerId }) {
      userContributionTimer {
        ...ContributionTimerFields
      }
    }
  }
`;
